import * as types from './types';
import LocalStorage from '../../utils/localStorage';

export const SET_LOADING = 'SET_LOADING';

export const setLoading = value => dispatch => {
    dispatch({
        type: SET_LOADING,
        payload: value,
    });
};

export const changeLocale = locale => dispatch => {
    LocalStorage.setItem('lang', locale);
    dispatch({
        type: types.CHANGE_LOCALE,
        payload: locale,
    });
};

export const changeTheme = theme => ({
    type: types.CHANGE_THEME,
    payload: theme,
});

export const changeUnreadMessageCount = count => ({
    type: types.CHANGE_UNREAD_MESSAGE_COUNT,
    payload: count,
});

export const changeTranslationMode = payload => ({
    type: types.CHANGE_TRANSLATION_MODE,
    payload,
});
